import React from 'react';

const ContactRow = ({ name, email, message, onDelete, id }) => {
  const handleDeleteContact = () => {
    const confirmed = window.confirm('Are you sure you want to delete this contact?');
    if (confirmed) {
      onDelete(id);
    }
  };

  const handleReply = () => {
    window.location.href = 'mailto:' + email;
  };

  return (
    <>
      <div className="bg-dark m-4"style={styles.messageDialog}>
        <h4 style={styles.sender}>{name}</h4>
        <div style={styles.email}>{email}</div>
        <div style={styles.message}>{message}</div>
        <button style={styles.deleteButton} onClick={handleDeleteContact}>
          Delete
        </button>
        <button style={styles.replyButton} onClick={handleReply}>
          Reply
        </button>
      </div>
    </>
  );
};

export default ContactRow;

const styles = {
  messageDialog: {
    backgroundColor: 'light',
    color: 'white',
    padding: '10px',
    marginBottom: '10px',
    borderRadius: '10px',
    fontWeight:"bolder",
    maxWidth: '70%',
    alignSelf: 'flex-start',
  },
  sender: {
    fontWeight: 'bold',
    color:"white",
    marginBottom: '5px',
  },
  email: {
    color: "white",
    marginBottom: '5px',
  },
  message: {
    marginBottom: '10px',
  },
  deleteButton: {
    backgroundColor: '#dc3545',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '5px 10px',
    marginRight: '5px',
    cursor: 'pointer',
  },
  replyButton: {
    backgroundColor: '#28a745',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '5px 10px',
    cursor: 'pointer',
  },
};